import axios from "axios";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import { useParams } from "react-router-dom";
import Select from "react-select";
import dollor from "../../../assets/icons/dollar.svg";
import percentage from "../../../assets/icons/percentage.svg";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const AddDupliacteData = ({ showModal, formData, disable, error, onSetFormData, onSetError, handleSubmit, handleClose, from, id }) => {
  const [config] = useAuth();
  const { id: paramId } = useParams();
  const [loading, setLoading] = useState(false);
  const [sellerOptions, setSellerOptions] = useState([]);
  const selectRef = useRef(null);
  const [buyerOptions, setBuyerOptions] = useState([]);
  const [bdsOptions, setBdsOptions] = useState([]);
  const [bdsSellerOptions, setBdsSellerOptions] = useState([]);
  const [offerVisionOptions, setOfferVisionOptions] = useState([]);
  const [brBuyerOptions, setBrBuyerOptions] = useState([]);
  const [brSellerOptions, setBrSellerOptions] = useState([]);
  const [sellerData, setSellerData] = useState({ list_type: "", property_name: "", property_address: "", type_id: "", asking_cap_rate: "", asking_price: "", noi: "", })
  const [buyerData, setBuyerData] = useState({ list_type: "", property_name: "", property_address: "", type_id: "", asking_cap_rate: "", asking_price: "", noi: "", });

  useEffect(() => {
    setSellerData(sellerData => ({ ...sellerData, list_type: formData.seller_list_type }));
    setBuyerData(buyerData => ({ ...buyerData, list_type: formData.list_type }));
  }, []);

  const handleChange = (value, name) => {
    onSetError({ ...error, [name]: "" });
    onSetFormData({ ...formData, [name]: value });
  };

  const fetchSuggestions = (inputValue, type, listType) => {
    if (inputValue !== "") {
      axios
        .get(`${BASE_URL}/get-datalisting?list=${listType}&search=${inputValue}`, config)
        .then((res) => {
          const data = res?.data?.data;

          let options = [];

          if (data?.exclusive?.length) {
            const exclusiveOptions = data.exclusive.map((el) => ({
              value: el?.id,
              label: `${el?.property?.property_name || ""}, ${el?.property?.street_address || ""}, ${el?.property?.city || ""}, ${el?.property?.state || ""}`,
              noi: el?.property?.anual_rent ?? "",
              asking_cap_rate: el?.property?.asking_cap_rate,
              asking_price: el?.property?.asking_price,
            }));
            if (listType === "exclusive") {
              options = exclusiveOptions;
              if (type === "seller") {
                setSellerOptions(options);
              } else if (type === "buyer") {
                setBuyerOptions(options);
              }
            }
          }

          if (data?.leads?.length) {
            const leadOptions = data.leads.map((el) => ({
              value: el?.id,
              label: `${el?.contact?.first_name || ""} ${el?.contact?.last_name || ""}`.trim(),
            }));
            if (listType === "leads") {
              options = leadOptions;
              if (type === "seller") {
                setSellerOptions(options);
              } else if (type === "buyer") {
                setBuyerOptions(options);
              }
            }
          }

          if (data?.contact_list?.length) {
            const contactOptions = data.contact_list.map((el) => ({
              value: el?.id,
              label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
            }));
            if (listType === "contacts") {
              options = contactOptions;
              if (type === "seller") {
                setSellerOptions(options);
              } else if (type === "buyer") {
                setBuyerOptions(options);
              }
            }
          }

          if (data?.length) {
            const userOptions = data.map((el) => ({
              value: el?.id,
              label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
            }));

            if (listType === "BDS_Buyer") {
              options = userOptions;
              setBdsOptions(options);
            } else if (listType === "BDS_Seller") {
              options = userOptions;
              setBdsSellerOptions(options);
            } else if (listType === "Broker_Buyer") {
              options = userOptions;
              setBrBuyerOptions(options);
            } else if (listType === "Broker_Seller") {
              options = userOptions;
              setBrSellerOptions(options);
            }
          }


        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    }
  };

  const fetchOfferVision = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/offer-version-data`, config)
      .then((res) => {
        const data = res?.data?.data;
        if (!data || typeof data !== "object") {
          setOfferVisionOptions([]);
          return;
        }
        const options = Object.entries(data).map(([key, value]) => ({
          value: key,
          label: value
        }));

        setOfferVisionOptions(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  const calculateOfferPrice = (noi, capRate) => {
    if (!noi || !capRate || capRate === "0") return "";
    const capDecimal = parseFloat(capRate) / 100;
    if (capDecimal === 0) return "";
    const price = Math.round(parseFloat(noi) / capDecimal);
    return price.toString();
  };

  const calculateOfferCapRate = (noi, price) => {
    if (!noi || !price || price === "0") return "";
    const capRate = ((parseFloat(noi) / parseFloat(price)) * 100).toFixed(2);
    return capRate;
  };

  const updateFormWithFormula = (newFormData) => {
    onSetFormData({ ...formData, ...newFormData });
  };

  const handleNoiChange = (e) => {
    const noiValue = e.target.value;
    let updates = { noi_rent: noiValue };

    if (formData.offer_cap_rate && noiValue !== "") {
      updates.offer_price = calculateOfferPrice(noiValue, formData.offer_cap_rate);
    } else if (formData.offer_price && noiValue !== "") {
      updates.offer_cap_rate = calculateOfferCapRate(noiValue, formData.offer_price);
    }

    updateFormWithFormula(updates);
  };

  const handleOfferCapRateChange = (e) => {
    const capRateValue = e.target.value;
    const regex = /^\d*\.?\d*$/;
    const numValue = parseFloat(capRateValue);
    if (capRateValue === "" || (regex.test(capRateValue) && !isNaN(numValue))) {
      let updates = { offer_cap_rate: capRateValue };

      if (formData.noi_rent && capRateValue !== "" && numValue > 0 && numValue <= 100) {
        updates.offer_price = calculateOfferPrice(formData.noi_rent, capRateValue);
      }

      updateFormWithFormula(updates);
    }
  };

  const handleOfferPriceChange = (e) => {
    const priceValue = e.target.value;
    const regex = /^\d*$/;
    if (priceValue === "" || regex.test(priceValue)) {
      let updates = { offer_price: priceValue };

      if (formData.noi_rent && priceValue !== "") {
        updates.offer_cap_rate = calculateOfferCapRate(formData.noi_rent, priceValue);
      }

      updateFormWithFormula(updates);
    }
  };

  useEffect(() => {
    if (showModal && id) {
      setLoading(true);
      axios
        .get(`${BASE_URL}/offer-listing?id=${id}`, config)
        .then((res) => {
          const data = res?.data?.data;
          if (data) {
            onSetFormData((prev) => ({
              ...prev,
              offer_cap_rate: data?.offer_cap_rate ?? "",
              offer_price: data?.offer_price ?? "",
              created_at: data?.created_at
                ? new Date(data.created_at)
                : new Date(),
              offer_version: data?.type ?? "",
            }));
          }
        })
        .catch((err) => {
          if (
            err.response?.data?.message &&
            err.response?.data?.message !== "Too Many Attempts."
          ) {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [showModal, id]);



  useEffect(() => {
    if (showModal) {
      fetchOfferVision();
    }
  }, [showModal]);

  return (
    <form onSubmit={handleSubmit}>

      <div className="flex gap-4">
        <div className="mt-6 w-[48%]">
          <label className="dark-H head-4 mb-2">Offer Date</label>
          <DatePicker
            className="body-N"
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            selected={formData.created_at ? new Date(formData.created_at) : null}
            onChange={(value) => {
              onSetError({ ...error, created_at: "" });
              handleChange(value, "created_at");
            }}
          />
          {error?.created_at && <p className="body-S red-D">{error?.created_at}</p>}
        </div>

        <div className="mt-5 w-[48%]">
          <label className="dark-H head-4 mb-2 required:*:">
            Offer Version
          </label>
          <div className="mt-1.5">
            <Select
              ref={selectRef}
              className="body-N"
              options={offerVisionOptions}
              placeholder={"Offer version"}
              value={offerVisionOptions?.find((option) => option?.value === formData.offer_version)}
              onChange={(option) => {
                onSetError("offer_version");
                handleChange(option?.value, "offer_version");
              }}
            />
          </div>
          {error?.offer_version && <span className="body-S red-D">{error?.offer_version}</span>}
        </div>
      </div>

      <div className="mt-5">
        <label className="dark-H head-4 mb-2">NOI</label>
        <InputWithIcon
          icon={dollor}
          type="number"
          placeholder="NOI"
          value={formData?.noi_rent || ""}
          onChange={handleNoiChange}
          onWheel={(e) => e.target.blur()}
        />
        {error?.noi_rent && <span className="body-S red-D">{error?.noi_rent}</span>}
      </div>

      <div className="flex gap-4">
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2 ">
            Offer Cap Rate<span className="red-D">*</span>
          </label>
          <InputWithIcon
            icon={percentage}
            type="number"
            placeholder="Offer Cap Rate"
            value={formData?.offer_cap_rate}
            onChange={handleOfferCapRateChange}
            onWheel={(e) => e.target.blur()}
          />

          {error?.offer_cap_rate && <span className="body-S red-D">{error?.offer_cap_rate}</span>}
        </div>

        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2">
            Offer Price<span className="red-D">*</span>
          </label>

          <InputWithIcon
            icon={dollor}
            type="number"
            placeholder="Offer Price"
            value={formData?.offer_price}
            onChange={handleOfferPriceChange}
            onWheel={(e) => e.target.blur()}
          />

          {error?.offer_price && <span className="body-S red-D">{error?.offer_price}</span>}
        </div>
      </div>

      <div className="mt-6">
        <button type="submit" disabled={disable || loading} className="save-button light-L head-5 green-bg-H">
          Save
        </button>
        <button type="button" onClick={handleClose} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddDupliacteData;